module.exports = __webpack_public_path__ + "static/media/5.Mixture Machine.dec760f5.jpg";